<template>
  <div v-if="filters.length > 0" class="filters-info">
    <v-subheader>
      {{ lang.historic.filters.title }}
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            @click.stop="clear_()"
            class="mr-2 clear-btn"
            color="gray darken-2"
          >
            <v-icon small>mdi-broom</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.historic.filters.clear }}</span>
      </v-tooltip>
    </v-subheader>
    <v-row
      v-for="(filter, i) in filters"
      :key="i"
      class="filter"
    >
      <v-col cols="5" class="filter-label">
        {{ filter.label }}
      </v-col>
      <v-col cols="7" class="filter-text">
        <p v-if="!Array.isArray(filter.text)">{{ filter.text }}</p>
        <template v-else>
          <p
            v-for="(value, i_) in filter.text"
            :key="`val-${i_}`"
          >
            {{ value }}
          </p>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    filters () {
      this.value
      let filters = this.value,
          filters_ = []
      Object.keys(filters).forEach((key) => {
        let value = filters[key]
        let label = false
        let text = false
        switch (key) {
          case 'date': {
            label = this.lang.historic.filters.date_range.date
            text = (value.length === 2 && (value[0] && value[0] !== '0000-00-00' && value[1] && value[1] !== '0000-00-00') ? `${this.formatDate(value[0], false)} ~ ${this.formatDate(value[1], false)}` : false)
            break
          }
          case 'type': {
            let types = (value > 0 ? this.get_global.defaults.options.financial.cashflow.types : false),
                type = (types ? types.find((el) => el.id === value) : false)
            label = this.lang.historic.filters.type.title
            text = (type ? type.title : false)
            break
          }
          case 'payment': {
            let methods = this.get_global.defaults.options.financial.cashflow.methods || []
            label = this.lang.historic.filters.payment.title
            if (value.length > 0) {
              text = value.map(function (id) {
                let method = methods.find((el) => el.id === id)
                return method.title || ''
              })
            }
            break
          }
          case 'categories': {
            let categories = this.get_global.defaults.options.financial.cashflow.categories || []
            label = this.lang.historic.filters.categories.title
            if (value.length > 0) {
              text = value.map(function (id) {
                let categorie = categories.find((el) => el.id === id)
                return categorie.title || ''
              })
            }
            break
          }
        }
        if (label && text) filters_.push({ label, text })
      })
      return filters_
    }
  },
  methods: {
    clear_ () {
      this.$emit('clearFilters', true)
    }
  }
}
</script>
